import { render, staticRenderFns } from "./search-tags.vue?vue&type=template&id=2e98dc30"
import script from "./search-tags.vue?vue&type=script&lang=ts"
export * from "./search-tags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports